import React, { Component } from 'react';
import './App.css';
import {
  BrowserRouter as Router,
  Route
} from 'react-router-dom';
import base from './base';
import MyNavBar from './components/MyNavBar';
import Dashboard from './components/Dashboard';
import FreeWorkout from './components/FreeWorkout';
import Exercises from './components/Exercises';
import SplashPage from './components/SplashPage';

class App extends Component {
  constructor(props) {
    super(props);
    this.authenticate = this.authenticate.bind(this);
    this.authHandler = this.authHandler.bind(this);
    this.logout = this.logout.bind(this);
    this.state = {
      user: null
    }
  }

  componentDidMount() {
    base.onAuth((user) => {
      if(user) {
        this.authHandler(null, { user });
      }
    })
  }

  authenticate(provider) {
    base.authWithOAuthPopup(provider, this.authHandler);
  }

  authHandler(err, authData) {
    if (err) {
      console.error(err);
      return;
    }
    this.setState({user: authData.user});
  }

  logout() {
    base.unauth();
    this.setState({ user: null });
  }

  render() {
    if (!this.state.user) {
      return (
        <SplashPage authenticate={this.authenticate} />
      );
    }

    return (
      <Router>
        <div>
          <MyNavBar logout={this.logout} />
          <div className="container">
            <Route exact path="/" render={( props ) => <Dashboard user={this.state.user} {...props} />} />
            <Route path="/dashboard" render={( props ) => <Dashboard user={this.state.user} {...props}/>} />
            <Route exact path="/exercises" render={( props ) => <Exercises uid={this.state.user.uid} {...props} />} />
            <Route path="/workouts/:workoutKey" render={({ match }) => <FreeWorkout uid={this.state.user.uid} workoutKey={match.params.workoutKey} />} />
          </div>
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js